import { render, staticRenderFns } from "./TabConfiguratorCategories.vue?vue&type=template&id=1b16200d&"
import script from "./TabConfiguratorCategories.vue?vue&type=script&lang=js&"
export * from "./TabConfiguratorCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports